import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=85f1ef4e&scoped=true"
var script = {}
import style0 from "./Login.vue?vue&type=style&index=0&id=85f1ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f1ef4e",
  null
  
)

export default component.exports